import { css, cx } from 'emotion';
import {
	tabletPortraitMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import ArrowIcon from './arrow.svg';

export const arrowStyle = side =>
	css({
		width: '51px',
		height: '51px',
		display: 'block',
		position: 'absolute',
		top: '70px',
		left: side === 'left' ? '-26px' : 'auto',
		right: side === 'left' ? 'auto' : '-26px',
		padding: '0',
		border: 'none',
		outline: 'none',
		zIndex: '1',
		filter: 'drop-shadow(0 6px 12px rgba(0,0,0,0.18))',
		cursor: 'pointer',

		'&:after': {
			content: '" "',
			display: 'block',
			width: '100%',
			height: '100%',
			background: `transparent url(${ArrowIcon}) no-repeat`,
			transform: side === 'left' ? 'scaleX(-1)' : 'none',
		},
	});

export const wrapperStyle = css({
	position: 'relative',
	width: '100%',
});

export const maskStyle = css({
	overflow: 'hidden',
	width: '100%',
});

export const innerStyle = css({
	display: 'flex',
	alignItems: 'stretch',
	position: 'relative',
	left: '0',
	transition: 'all 300ms',

	'& > [data-component=Card]': {
		width: 'calc((100% - 48px) / 3)',
		flexShrink: '0',
		margin: '0 12px',

		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			width: 'calc((100% - 24px) / 2)',
		},

		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			width: '100%',
		},

		'&:first-of-type': {
			marginLeft: '0',
		},

		'&:last-of-type': {
			marginRight: '0',
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/carousel/styles.js